/** Ruta publica unica del logotipo oficial; no se duplica en componentes consumidores. */
export const RUTA_LOGO_MM_PADEL = '/brand/mm-padel-logo.jpeg';

export type TamanoBrandLogo = 'compacta' | 'normal' | 'amplia';

interface DimensionesLogo {
  readonly ancho: number;
  readonly alto: number;
}

const DIMENSIONES: Record<TamanoBrandLogo, DimensionesLogo> = {
  compacta: { ancho: 72, alto: 72 },
  normal: { ancho: 80, alto: 80 },
  amplia: { ancho: 120, alto: 120 },
};

interface PropiedadesBrandLogo {
  readonly tamano?: TamanoBrandLogo;
}

/**
 * Logotipo oficial M&M Pádel.
 *
 * El JPEG tiene fondo blanco y proporcion 1:1. El componente concentra su ruta, texto
 * alternativo y tamanos permitidos para que las pantallas no creen variantes de marca.
 */
export function BrandLogo({ tamano = 'normal' }: PropiedadesBrandLogo): React.JSX.Element {
  const dimensiones = DIMENSIONES[tamano];

  return (
    <img
      alt="M&M Pádel"
      className={`brand-logo brand-logo--${tamano}`}
      height={dimensiones.alto}
      src={RUTA_LOGO_MM_PADEL}
      width={dimensiones.ancho}
    />
  );
}
